var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdg-wrapper-container"},[_c('router-view'),_c('div',{staticClass:"back-button",on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"fas fa-chevron-circle-left"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }